/*
 * @Desc: 问题单模块相关所有接口
 * @Author: hedahai
 * @Date: 2020-10-26 16:20:10
 */

import http from '@/server/httpServer.js'


// 获取默认问题模板列表
export const getDefalutQuestionListApi = () =>
  http({ url: "/gzzc/question/defaultQuestionList", method: "post"}, {})

// 提交问题 
export const submitQuestionsApi = (data) =>
  http({ url: "/scavenger/question/addQuestion", method: "post"}, data)

// 调解员问题列表
export const mediatorQuestionListApi = (data) =>
  http({ url: "/scavenger/question/questionAnswerList", method: "post"}, data)
// 导出问题单
export const getQuestionExcel = (data) =>
  http({ url: "/scavenger/question/getQuestionExcel", method: "post"}, data)

// 用户问题列表
export const userQuestionListApi = (data) =>
  http({ url: "/scavenger/question/userQuestionAnswerList", method: "post"}, data)

// 用户保存答案
export const userSaveAnswerApi = (data) =>
  http({ url: "/scavenger/question/saveQuestionAnswer", method: "post"}, data)

// 用户‘一键提交’答案
export const usersubmitAnswersApi = (data) =>
  http({ url: "/scavenger/question/submitQuestionAnswer", method: "post"}, data)

// 调解员解锁问题
export const mediatorUnlockQuestionApi = (data) =>
  http({ url: "/scavenger/question/unlockQuestion", method: "post"}, data)

// 调解员删除问题
export const deleteQuestion = (data) =>
  http({ url: "/gzzc/question/deleteQuestion", method: "post"}, data)

  // 调解员删除问题
export const userCanAnswer = (data) =>
http({ url: "/scavenger/question/canUserAnswer", method: "post"}, data)

/**
 * 问题单一键保存
 * @param  {Object} data 请求参数
 * @return {promise}
 */

export const saveAllQuestionAnswer = (data) =>
http({ url: "/scavenger/question/saveAllQuestionAnswer", method: "post"}, data)

/**
 * 取消申请人回答
 * @param  {Object} data 请求参数
 * @return {promise}
 */
export const cancleAnswer = (data) => 
http({ url: "/gzzc/question/cancelAnswer", method: "post"}, data)
